import instance from './instance'

const giftGalleryUrl = 'modules-coupon/gift-gallery'

export const getGiftGalleryList = (page: number, pageSize: number, filterKey: any) =>
  instance.get(`${giftGalleryUrl}?page=${page}&pageSize=${pageSize}&filterkey=${filterKey}`)

export const getGiftGalleryById = (id: number) => instance.get(`${giftGalleryUrl}/${id}`)

export const createGiftGallery = (payload: any) => instance.post(giftGalleryUrl, payload)

export const updateGiftGallery = (id: any, payload: any) =>
  instance.post(`${giftGalleryUrl}/${id}`, payload)

export const deleteGiftGallery = async (id: number) =>
  await instance.delete(`${giftGalleryUrl}/${id}`)
